import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import Desafios from "@/pages/admin/Desafios";
import { pageHead } from "@/lib/seo";

const busca = z.object({ novo: z.boolean().optional().catch(undefined) });

export const Route = createFileRoute("/admin/desafios/")({
  validateSearch: busca,
  head: () => pageHead({ title: "Desafios | Painel", path: "/admin/desafios", noindex: true }),
  component: Desafios,
});
